const PrimaryBtn = ({ children, submitBtn, type }) => {
  return (
    <button className="btn" type={type} onClick={submitBtn}>
      {children}
    </button>
  );
};

export default PrimaryBtn;
